import "core-js/modules/es.array.reduce.js";
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
dayjs.extend(weekday); // 获取本周周一的日期

const getCurrentMonday = () => {
  return dayjs().weekday(1);
};

const isToday = value => {
  return dayjs().isSame(value, 'date');
};

const weekNames = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
export default {
  name: 'WeekTable',
  props: {
    /**
     * 显示的名称
     */
    title: {
      type: String,
      default: '选择日期'
    },

    /**
     * 当前选择的日期
     */
    value: {
      type: [Date, String]
    },

    /**
     * 表格数据
     */
    data: {
      type: Array,
      default: () => []
    },

    /**
     * 日期格式，可参考 https://day.js.org/docs/zh-CN/display/format
     */
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  data: () => ({
    // 当前视图开始的日期（周一）
    startDate: getCurrentMonday()
  }),
  computed: {
    tableProps() {
      const {
        title,
        value,
        format,
        ...other
      } = this.$attrs;
      return other;
    },

    weekMap() {
      const startDate = this.startDate ? dayjs(this.startDate) : getCurrentMonday();
      const value = this.value ? dayjs(this.value) : null;
      return [...new Array(7)].reduce((ret, item, index) => {
        const day = startDate.add(index, 'day');
        const today = isToday(day);
        return { ...ret,
          [index]: {
            date: day.date(),
            label: today ? '今天' : weekNames[index],
            today,
            active: value ? value.isSame(day, 'date') : false,
            value: day.format(this.format),
            week: day.weekday() || 7
          }
        };
      }, {});
    },

    weekList() {
      return [...new Array(7)].map((item, index) => index);
    },

    weekData() {
      return Object.values(this.weekMap);
    }

  },
  methods: {
    jump(step) {
      if (step === 0) {
        this.startDate = getCurrentMonday();
      } else {
        this.startDate = dayjs(this.startDate).add(step, 'week');
      }
      /**
       * 切换周时触发，参数为切换后的周信息，格式为数组
       */


      this.$emit('change', [...this.weekData]);
    }

  }
};